export default theme => ({

  noPadding: {
    paddingLeft: 0,
    paddingRight: 0
  },

  dimmed: {
    opacity: 0.4
  },

  scrollable: {
    overflowX: 'auto',
    overflowY: 'hidden'
  },

  clearFocus: {
    backgroundColor: 'transparent'
  },


});





// WEBPACK FOOTER //
// ./src/styles/components/CodeInfoSection.js